import React from 'react';
import { getLatestPing } from '../utilities/time';

export default function SpeciesListEntry(props: any) {
  const trackedCount = props.item.individuals.length;

  function handleClick() {
    props.onSelected(props.item);
  }

  return (
    <li className='species-list-item' onClick={handleClick}>
      <div className='species-list-item-details'>
        <span className='species-list-item-title'>{props.item.name}</span>
        <span className='species-list-item-meta'>{trackedCount} tracked {trackedCount === 1 ? 'animal' : 'animals'}</span>
        <span className='species-list-item-meta'>Latest Ping: {getLatestPing(props.item.individuals)} days ago</span>
      </div>
      <span className='species-list-item-arrow' aria-hidden='true'>&gt;</span>
    </li>
  )
}